/*
	generic Page component
*/

<template>
	<div>
		<h1 class="red">Page View</h1>
	</div>

</template>


<script>
	export default {

		data () {
			return {
			}
		}
	}
</script>


<style>
	.red {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// PageView.vue?5be56c76